module.exports = __webpack_public_path__ + "img/ps5oow0k67x5hlefum1szp7nn31mekuqdq4041e6d9-9f68-40e1-b8d0-07c0ffb28276.cc6c59a1.png";